import * as XLSX from 'xlsx';

export const exportToExcel = (jsonData, headers, fileName) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Map the JSON data to match the headers
    const mappedData = jsonData.map((item) => {
        const mappedItem = {};
        headers.forEach((header) => {
            mappedItem[header.label] = item[header.key];
        });
        return mappedItem;
    });

    // Convert the mapped JSON array to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    // Get the number of rows in the data
    const numberOfRows = mappedData.length;

    // Merge cells in the second-to-last and last rows
    // worksheet['!merges'] = [
    //     { s: { r: numberOfRows - 2, c: 0 }, e: { r: numberOfRows - 2, c: 2 } },  // Merge the second-to-last row from column A to C
    //     { s: { r: numberOfRows - 1, c: 0 }, e: { r: numberOfRows - 1, c: 2 } }   // Merge the last row from column A to C
    // ];


    // Apply the header style to the first row (explicit headers)
    headers.forEach((header, index) => {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index }); // Header row is 0
        if (!worksheet[cellAddress]) worksheet[cellAddress] = {};
        worksheet[cellAddress].v = header.label; // Set the header label
    });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate a binary string for the workbook
    const workbookOut = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary', cellStyles: true });

    // Convert the binary string to an array buffer
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    };

    // Create a Blob and trigger a download
    const blob = new Blob([s2ab(workbookOut)], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
};
